import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
interface MissingInfoCardProps {
  title: string;
  description: string;
  actionLabel: string;
  onAction: () => void;
}
export function MissingInfoCard({
  title,
  description,
  actionLabel,
  onAction
}: MissingInfoCardProps) {
  return <div role="alert" className="flex flex-col gap-4 rounded-2xl border border-amber-200 bg-amber-50 p-5 sm:flex-row sm:items-center sm:justify-between" data-id="element-134" data-mp="173pdhnvrbncy">
      <div className="flex gap-3" data-id="element-135" data-mp="1kxgpr40vhlcd">
        <AlertTriangleIcon aria-hidden="true" className="mt-0.5 h-5 w-5 shrink-0 text-amber-600" data-id="element-136" data-mp="1guse6okry0bp" />
        <div data-id="element-137" data-mp="1uu1stjtc0mdk">
          <p className="text-sm font-semibold text-amber-900" data-id="element-138" data-mp="1usqn3egbt4jt">{title}</p>
          <p className="mt-1 text-sm text-amber-800" data-id="element-139" data-mp="1pu73hkp7g4um">{description}</p>
        </div>
      </div>
      <button type="button" onClick={onAction} className="inline-flex shrink-0 items-center justify-center rounded-xl bg-amber-600 px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-amber-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-600 focus-visible:ring-offset-2" data-id="element-140" data-mp="fiorct56atf">
        {actionLabel}
      </button>
    </div>;
}